import { useEffect, useRef } from "react"

import { Flex } from "@/atoms"
import { useLogger } from "@/hooks/useLogger"
import { useTranslation } from "@/hooks/useTranslation"
import { useIntegration } from "@/pages/IntegrationsPage/hooks/useIntegration"
import { PackageRegistryConfigurationItem } from "./PackageRegistryConfigurationItem"

import type { PackageRegistryConfiguration } from "@/api/useIntegrations.types"
import type { PackageRegistryConfigurationTabProps } from "."

export const PackageRegistryConfigurationTab = (
  props: PackageRegistryConfigurationTabProps
) => {
  const { t } = useTranslation("translation", {
    keyPrefix: "integrations.packageRegistry.configuration"
  })
  const { logger, EVENTS } = useLogger()
  const [data] = useIntegration(props)
  const configuration = data?.configuration as
    PackageRegistryConfiguration | undefined
  const entries = configuration?.installations || []
  const logged = useRef(false)

  useEffect(() => {
    if (logged.current || !configuration) return

    logged.current = true
    logger.info(
      EVENTS.ANALYTIC_EVENTS.INTEGRATIONS.PACKAGE_REGISTRY.LIST_VIEWED,
      { entries_count: entries.length }
    )
  }, [configuration, entries.length, logger, EVENTS])

  if (!entries.length) return <>{t("noData")}</>

  return (
    <Flex vertical gap={8}>
      {entries.map((entry) => (
        <PackageRegistryConfigurationItem
          key={entry.id}
          entry={entry}
          {...props}
        />
      ))}
    </Flex>
  )
}
